import { useEffect, useState } from 'react';
import { PerfUtilService } from '../services/util/perf-util.service';

export const useRealScreenSize = () => {
    const getScreenSizes = () => ({
        width: window.innerWidth,
        height: window.innerHeight,
        isPortrait: window.innerWidth < window.innerHeight,
    });

    const [screenSizes, setScreenSizes] = useState(getScreenSizes());

    useEffect(() => {
        const calculate = () => {
            setScreenSizes(getScreenSizes());
        };

        const calculateThrottled = PerfUtilService.throttle(calculate, 100);

        window.addEventListener('resize', calculateThrottled);
        window.addEventListener('scroll', calculateThrottled);

        return () => {
            window.removeEventListener('resize', calculateThrottled);
            window.removeEventListener('scroll', calculateThrottled);
        };
    }, []);

    return screenSizes;
};
